import React from 'react';
import { Row, Col, Form, Radio } from 'antd';
import styles from './index.module.less';
// import { Message, Icon } from 'semantic-ui-react';
import RegisterLogo from '@/common/assets/images/RegisterLogo.png';
import martrimonyLogo from '@/common/assets/icons/logo.svg';

const LoginPage = ({
  maritial_Status,
  family_Status,
  family_Value,
  family_Type
}) => {
  // const navigate = useNavigate();
  console.log('maritial_Status', maritial_Status);
  return (
    <>
      <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} md={6} sm={6} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={RegisterLogo} />
        </Col>

        <Col xs={24} xl={13} sm={6} md={6} className={styles.sideheader}>
          <div className={styles.headerload}>
            <img
              src={martrimonyLogo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>
          <div
            className={styles.sideheader1}
            // style={{ backgroundColor: '#f9f1dc' }}
          >
            <h1 className={styles.headingsmall}>Find Your</h1>
            <h1 className={styles.someonestyles}>Special someone</h1>
          </div>

          <div className={styles.right_outer_container}>
            <div className={styles.container}>
              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Marital Status</h3>
                <Form.Item
                  name="maritalStatus"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your marital status!'
                    }
                  ]}
                >
                  <Radio.Group>
                    <Row gutter={[24]}>
                      {maritial_Status?.length
                        ? maritial_Status.map((mstatus, index) => (
                            <Col span={6} key={index}>
                              <Radio value={mstatus.id}>
                                {mstatus.marital_status}
                              </Radio>
                            </Col>
                          ))
                        : null}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Family Status</h3>
                <Form.Item
                  name="familyStatus"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your family status!'
                    }
                  ]}
                >
                  <Radio.Group>
                    <Row gutter={[24]}>
                      {family_Status?.length
                        ? family_Status.map((fstatus, index) => (
                            <Col span={6} key={index}>
                              <Radio value={fstatus.id}>{fstatus.status}</Radio>
                            </Col>
                          ))
                        : null}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Family Values</h3>
                <Form.Item
                  name="familyValues"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your family values!'
                    }
                  ]}
                >
                  <Radio.Group>
                    <Row gutter={[24]}>
                      {family_Value?.length
                        ? family_Value.map((fvalue, index) => (
                            <Col span={6} key={index}>
                              <Radio value={fvalue.id}>{fvalue.values}</Radio>
                            </Col>
                          ))
                        : null}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Family Type</h3>
                <Form.Item
                  name="familyType"
                  rules={[
                    {
                      required: true,
                      message: 'Please select your family type!'
                    }
                  ]}
                >
                  <Radio.Group>
                    <Row gutter={[24]}>
                      {family_Type?.length
                        ? family_Type.map((ftype, index) => (
                            <Col span={6} key={index}>
                              <Radio value={ftype.id}>{ftype.type}</Radio>
                            </Col>
                          ))
                        : null}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Disabilities</h3>
                <Form.Item
                  name="disabilities"
                  rules={[
                    {
                      required: true,
                      message: 'Please select disabilities status!'
                    }
                  ]}
                >
                  <Radio.Group>
                    <Row gutter={[24]}>
                      <Col span={6}>
                        <Radio value="none">None</Radio>
                      </Col>
                      <Col span={6}>
                        <Radio value="yes">Yes</Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>

            {/* Submit Button */}
            {/* <Form.Item className={styles.submitButtonItem}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={styles.submitButton}
                >
                  Next
                </Button>
              </Form.Item> */}
            {/* </Form> */}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LoginPage;
